import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import AboutAQ from "../views/AboutAQ.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/reserva/:id_pedido",
    name: "Home",
    component: Home
  },
  {
    path: "/Terminos&condiciones",
    name: "About",
    component: About
  },
  {
    path: "/Terminos&condicionesAQ",
    name: "AboutAQ",
    component: AboutAQ
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
export default router;
